import { getInitiativeStatuses } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesStatusesGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreInitiativesStatuses',
	receive: true,
	request: false,
	requestHandler: async() => {
		const result = await getInitiativeStatuses();

		return {
			...result,
			data: result.data?.initiativeStatuses
		};
	},
	yieldType: SagaYieldType.Latest
});
